/**
 *
 * ModalContent
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import ModalLogin from './ModalLogin';
import ModalSignUp from './ModalSignUp';

class ModalContent extends React.PureComponent {
  render() {
    const { action, onClose, onSignUp, type } = this.props;
    const isLogin = action !== 'sign-up';

    return isLogin ? (
      <ModalLogin onClose={onClose} onSignUp={onSignUp} type={type} />
    ) : (
      <ModalSignUp onClose={onClose} onSignUp={onSignUp} type={type} />
    );
  }
}

ModalContent.propTypes = {
  action: PropTypes.string,
  onClose: PropTypes.func,
  onSignUp: PropTypes.func,
  type: PropTypes.string,
};

export default ModalContent;
